module.exports = __webpack_public_path__ + "img/newlogo3.23a6a112.png";